import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import * as Sentry from '@sentry/browser';

const styles = {
	button: {
		lineHeight: '30px',
		backgroundColor: '#bfd730',
		alignSelf: 'center',
		margin: '20px',
		fontSize: '14px',
		fontWeight: 600,
		minWidth: 'fit-content',
		'&:hover': {
			backgroundColor: '#bfd730'
		}
	}
};

class SentryErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			eventId: null
		};
	}

	static getDerivedStateFromError(error) {
		return {
			hasError: true
		};
	}

	componentDidCatch(error, errorInfo) {
		if (process.env.REACT_APP_NODE_ENV !== 'development') {
			Sentry.withScope(scope => {
				scope.setExtras(errorInfo);
				const eventId = Sentry.captureException(error);
				this.setState({
					eventId
				});
			});
		}
	}

	handleException = () => {
		Sentry.showReportDialog({
			eventId: this.state.eventId
		});
	}

	render() {
		return (
			<section style={{ minHeight: '100vh', position: 'relative' }}>
				{this.state.hasError ? (
					<section
						style={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							minHeight: 'inherit',
							color: 'white',
							fontSize: '18px'
						}}
					>
						<div>Something went wrong.</div>
						{process.env.REACT_APP_NODE_ENV !== 'development' && (
							<Button variant='contained' className={this.props.classes.button} onClick={this.handleException}>
								Submit Feedback
							</Button>
						)}
					</section>
				) : (
					this.props.children
				)}
			</section>
		);
	}
}

export default withStyles(styles)(SentryErrorBoundary);
